



















































































import Vue from "vue";
import * as R from "ramda";

import { ApolloQueryResult } from "apollo-client";

import DAMAGE from "@/graphql/projects/Damage.gql";
import DAMAGE_CREATE from "@/graphql/projects/DamageCreate.gql";
import DAMAGE_UPDATE from "@/graphql/projects/DamageUpdate.gql";
import DAMAGE_TABLE from "@/graphql/projects/DamageTable.gql";
import PERSPECTIVES from "@/graphql/projects/Perspectives.gql";

import {
  Damage_damage,
  Damage,
  Perspectives,
  Project_project
} from "@/api-types";
import { DocumentNode } from "graphql";

export default Vue.extend({
  props: {
    editDamage: String,
    project: Object as () => Project_project
  },
  data: () => ({
    damage: null as Damage_damage | null,
    uploading: false,
    form: {
      number: "",
      perspective: null,
      suspicionPlan: "",
      overviewPlan: "",
      draft: ""
    } as { [key: string]: string | null },
    files: {} as { [key: string]: File },
    numberRules: [(v: string) => !!v || "Bitte Schadensnummer eingeben"],
    pdfRules: [
      (file: File) =>
        Boolean(file) ||
        file.size < 10000000 ||
        "Datei muss kleiner als 10MB sein",
      (file: File) =>
        Boolean(file) ||
        file.type === "application/pdf" ||
        "Datei muss eine PDF sein"
    ]
  }),
  apollo: {
    damage: {
      query: DAMAGE,
      variables() {
        return { id: this.editDamage };
      },
      result({ data }: ApolloQueryResult<Damage>) {
        ["number", "suspicionPlan", "overviewPlan", "draft"].forEach(key => {
          this.form[key] = (data.damage as any)[key];
        });
        this.form.perspective = data.damage!.perspective!
          ? data.damage!.perspective!.id
          : null;
      },
      skip() {
        return !this.editDamage.startsWith("/damage");
      }
    },
    perspectives: {
      query: PERSPECTIVES,
      variables() {
        return { viewer3d: this.project.viewer3d!.id };
      }
    }
  },
  methods: {
    async save() {
      if (!(this.$refs.form as any).validate()) return;
      this.uploading = true;
      const formData = new FormData();
      for (const prop in this.files) {
        const file = this.files[prop];
        formData.append(prop, file);
        (this.form as any)[prop] = file.name;
      }
      await this.axios.post("upload_project_files", formData);

      let mutation: DocumentNode;
      if (this.editDamage === "new") {
        mutation = DAMAGE_CREATE;
        this.form.damageTable = this.project.damageTable!.id;
      } else {
        mutation = DAMAGE_UPDATE;
        this.form.id = this.editDamage;
      }
      await this.$apollo.mutate({
        mutation,
        variables: {
          input: this.form
        },
        refetchQueries: [
          {
            query: DAMAGE_TABLE,
            variables: {
              id: this.project.damageTable!.id
            }
          }
        ]
      });
      this.uploading = false;
      this.close();
    },
    close() {
      this.$emit("close");
    }
  }
});
